import i18next from '@/helpers/i18n';
import { COUNTRY_OPTIONS } from './user-helpers.js';
import { daysOfWeek } from './date-helpers.js';
import { timeSelectAttrs } from '@/formkit/timeSelect';

export function addressSchema(options = {}) {
  const fieldOptions = options.fields || {};

  const scopedT = i18next.getFixedT(null, 'common', 'forms.address');
  return [
    {
      $el: 'div',
      attrs: {
        class: 'grid grid-cols-2 gap-2',
      },
      children: [
        {
          $formkit: 'text',
          label: scopedT('label.label'),
          name: 'label',
          validation: 'required|length:3,255',
          ...fieldOptions.label,
        },
      ],
    },

    {
      $el: 'div',
      attrs: {
        class: 'grid grid-cols-2 gap-2',
      },
      children: [
        {
          $formkit: 'text',
          label: scopedT('name.label'),
          name: 'name',
          validation: 'required',
          ...fieldOptions.name,
        },
        {
          $formkit: 'phonenumber',
          label: scopedT('phone.label'),
          name: 'phone',
          validation: 'required|phoneNumber',
          ...fieldOptions.phone,
        },
      ],
    },

    {
      $formkit: 'text',
      label: scopedT('line1.label'),
      name: 'line1',
      id: 'address-line1',
      autocomplete: 'street-address address-line1',
      validation: 'required',
      ...fieldOptions.line1,
    },
    {
      $formkit: 'text',
      label: scopedT('line2.label'),
      autocomplete: 'address-line2',
      name: 'line2',
      ...fieldOptions.line2,
    },

    {
      $el: 'div',
      attrs: {
        class: 'grid grid-cols-2 gap-2',
      },
      children: [
        {
          $formkit: 'text',
          label: scopedT('city.label'),
          name: 'city',
          validation: 'required',
          ...fieldOptions.city,
        },
        {
          $formkit: 'text',
          label: scopedT('postalCode.label'),
          name: 'postal_code',
          validation: 'required|postcode',
          ...fieldOptions.postalCode,
        },
      ],
    },
    {
      $el: 'div',
      attrs: {
        class: 'grid grid-cols-2 gap-2',
      },
      children: [
        {
          label: scopedT('country.label'),
          name: 'country',
          options: COUNTRY_OPTIONS(),
          value: 'NL',
          $formkit: 'select',
          autocomplete: 'country-name',
          validation: 'required',
          placeholder: scopedT('country.placeholder'),
          ...fieldOptions.country,
        },
      ],
    },
    {
      $formkit: 'text',
      label: scopedT('taxId.label'),
      name: 'taxId',
      help: scopedT('taxId.help'),
      ...fieldOptions.taxId,
    },
  ];
}

export function deliveryDetailsSchema(facilities) {
  const facilitiesT = i18next.getFixedT(null, 'address-facilities');
  const scopedT = i18next.getFixedT(
    null,
    'address',
    'modalEditAddress.labels.details'
  );
  const DELIVERY_DETAILS_SCHEMA = [
    {
      $formkit: 'group',
      name: 'details',
      children: [
        {
          label: scopedT('availabilityDays'),
          $formkit: 'togglebuttons',
          multiple: true,
          options: daysOfWeek('short').map((it, i) => ({
            value: i,
            label: it.toUpperCase(),
          })),
          name: 'availabilityDays',
        },
        {
          $el: 'div',
          attrs: {
            class: 'grid grid-cols-2 gap-2',
          },
          children: [
            {
              label: scopedT('availabilityStart.label'),
              name: 'availabilityStart',
              icon: 'schedule',
              placeholder: scopedT('availabilityStart.placeholder'),
              $formkit: 'autocomplete',
              ...timeSelectAttrs({ start: '08:00', end: '20:00' }),
              validation: 'naturallyBefore:availabilityEnd',
              'validation-messages': {
                naturallyBefore: scopedT('availabilityStart.validation'),
              },
            },
            {
              label: scopedT('availabilityEnd.label'),
              name: 'availabilityEnd',
              icon: 'schedule',
              placeholder: scopedT('availabilityEnd.placeholder'),
              $formkit: 'autocomplete',
              ...timeSelectAttrs({ start: '08:00', end: '20:00' }),
              validation: 'naturallyAfter:availabilityStart',
              'validation-messages': {
                naturallyAfter: scopedT('availabilityEnd.validation'),
              },
            },
          ],
        },
        {
          label: scopedT('floor'),
          name: 'floor',
          $formkit: 'number',
        },
        {
          label: scopedT('facilities'),
          name: 'facilities',
          $formkit: 'checkbox',
          class: 'simple-checkbox',
          options: facilities.map((it) => ({
            label: facilitiesT(it.name),
            value: it.id,
          })),
        },
        {
          label: scopedT('notes.label'),
          name: 'notes',
          help: scopedT('notes.help'),
          $formkit: 'textarea',
        },
      ],
    },
  ];

  return DELIVERY_DETAILS_SCHEMA;
}
